var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.15937 11.25C1.28437 10.8125 1.53437 10.4062 1.84687 10.0938L11.3469 0.59375C12.1281 -0.1875 13.4094 -0.1875 14.1906 0.59375L15.4094 1.8125C15.5031 1.90625 15.5969 2.03125 15.6594 2.125C16.1906 2.90625 16.0969 3.96875 15.4094 4.65625L5.90938 14.1562C5.87813 14.1875 5.81563 14.2188 5.78438 14.2812C5.47188 14.5312 5.12813 14.7188 4.75313 14.8438L2.31562 15.5625L0.971875 15.9688C0.721875 16.0312 0.440625 15.9688 0.253125 15.75C0.034375 15.5625 -0.028125 15.2812 0.065625 15.0312L0.440625 13.6875L1.15937 11.25ZM2.59687 11.6875L2.37812 12.4062L1.87812 14.125L3.59687 13.625L4.31563 13.4062C4.53438 13.3438 4.69063 13.25 4.84688 13.0938L12.0031 5.9375L10.0656 4L2.90937 11.1562C2.87812 11.1562 2.87812 11.1875 2.84687 11.2188C2.72187 11.3438 2.65937 11.5 2.59687 11.6875Z",
    fill: "#6162C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.08f2d965f41db60ef45cdcb671efbd67.svg";
export { ForwardRef as ReactComponent };